var React = require('react');

function E (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.98999 0.329998C3.82799 0.329998 4.02599 2.673 4.02599 9.174V23.826C4.02599 30.327 3.82799 32.67 0.98999 32.67V33H24.618V27.555H24.288C24.288 32.307 14.223 32.67 11.088 32.67H6.86399V15.048C7.39199 14.355 8.21699 13.86 9.17399 13.893C11.517 13.959 13.2 16.797 17.226 16.797C19.833 16.797 21.45 15.114 21.45 13.167H21.12C21.12 14.322 19.932 15.048 18.678 15.048C15.774 15.048 13.959 13.002 10.692 13.002C9.17399 13.002 7.85399 13.563 6.86399 14.52V0.329998H12.342C19.932 0.329998 24.288 2.112 24.288 4.323V4.455H24.618V0H0.98999V0.329998Z","fill":"currentColor"}));
}

E.defaultProps = {"width":"25","height":"33","viewBox":"0 0 25 33","fill":"none"};

module.exports = E;

E.default = E;
